import React, { ReactNode } from "react";

import { Tag } from "antd";

import { Icon, Typography, TypographyVariant } from "components";

interface TagNormalProps {
  text: string | ReactNode;
  dataTestId?: string;
  className?: string;
  icon?: string;
  color?: string;
  type?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  variant?: TypographyVariant;
}

export const TagNormal = ({
  dataTestId = "",
  icon,
  color = "",
  type = "",
  style,
  onClick = () => {},
  text,
  className = "",
  variant = "paragraph-xs",
}: TagNormalProps) => {
  const getIcon = () => {
    if (icon) {
      return <Icon iconName={icon} className="icon inline filled" />;
    }
    return <></>;
  };

  return (
    <Tag className={`${className} ${color} ${type}`} style={style} onClick={onClick} data-testid={dataTestId}>
      {getIcon()}
      <Typography variant={variant} bold>
        {text}
      </Typography>
    </Tag>
  );
};
